import { NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, input, InputSignal, Output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { InlineUserChipComponent } from '../../../../../shared/components/inline-user-chip/inline-user-chip.component';
import { TextAvatarComponent } from '../../../../../shared/components/text-avatar/text-avatar.component';
import { ELoadStatus } from '../../../../../state/state.interface';
import { EWorkflow } from '../../../items.interface';
import { ItemsService } from '../../../items.service';
import { IKamishibaiCard } from '../items-kamishibai.interface';
import { IKamishibaiCardStore } from './kamishibai-card.store';

@Component({
  imports: [
    TextAvatarComponent,
    MatIcon,
    MatIconButton,
    NgIf,
    TranslatePipe,
    MatTooltip,
    NgClass,
    InlineUserChipComponent,
  ],
  providers: [IKamishibaiCardStore],
  selector: 'app-kamishibai-card',
  styleUrl: './kamishibai-card.component.scss',
  templateUrl: './kamishibai-card.component.html',
})
export class KamishibaiCardComponent {
  public item: InputSignal<IKamishibaiCard> = input.required<IKamishibaiCard>();
  public isSimpleMode: InputSignal<boolean> = input.required<boolean>();

  @Output() public refreshDashboard: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    public readonly store: IKamishibaiCardStore,
    private readonly translate: TranslateService,
    private readonly itemsService: ItemsService,
  ) {
    this.store.dataStatus$.pipe().subscribe((data: ELoadStatus) => {
      if (data === ELoadStatus.success || data === ELoadStatus.failure) {
        this.refreshDashboard.emit();
      }
    });
  }

  public onStatusChange(event: Event): void {
    event.stopPropagation();

    const statusCategoryProcess: {
      [key in EWorkflow]: EWorkflow;
    } = {
      [EWorkflow.todo]: EWorkflow.inProgress,
      [EWorkflow.inProgress]: EWorkflow.done,
      [EWorkflow.done]: EWorkflow.todo,
    };

    const columnCategory: EWorkflow = statusCategoryProcess[this.item().status];

    this.store.changeItemStatusColor({
      columnCategory,
      itemId: this.item().id,
      nextItemId: null,
      previousItemId: null,
    });
  }

  public openItemEditModal(itemId: number, itemKey: string, boardKey: string): void {
    this.itemsService.openItemEditDialogAndSetUrl(
      boardKey,
      itemId,
      itemKey,
      this.translate.instant('button.saveChanges'),
    );
  }

  public triggerRefresh(): void {
    this.refreshDashboard.emit();
  }
}
